module.exports = __webpack_public_path__ + "img/2015073.a761c84b.svg";